// @flow

export const API_BASE_URL = 'https://api.onthebus.io';
// export const API_BASE_URL = 'http://localhost:8000';
export const IS_API_IN_DEV_MODE = false;
export const SOCKET_HOST = 'wss://ws.onthebus.io/socket';
export const REQUEST_TIMEOUT = 1000000;
export const OFFLINE_BUS_TIMEOUT = 60000;
export const PAGE_SIZE = 50;
export const PHONE_REGION = '+502';
export const PHONE_LENGTH = 8;
export const DEFAULT_SOCKET_ROLE = 'ADMIN';
export const MAPBOX_TOKEN = 'pk.eyJ1IjoicGplc3RyYWRhIiwiYSI6ImNqZXFndGF5NTBwbmUzM283bHFoOHhnMDUifQ.6f-uyo2U-ytGp7JTxsw5Vw';
export const GOOGLE_MAPS_API_KEY = 'AIzaSyDFpn-aemqLfXJpnCiGCdJ8KDHrWi9iH0c';
export const GOOGLE_MAPS_API_URL = 'https://maps.googleapis.com/maps/api';
export const DEFAULT_LOCATION = {
  longitude: -90.51756466528514,
  latitude: 14.6025202460013,
};
export const MAPBOX_STYLES = 'mapbox://styles/cesarchavez/cjf4bwi1g16d62rlgcr7qk5v8';

// Zendesk Settings
export const ZENDESK_KEY = 'aa3e6e29-1cca-4e9e-858a-72935e540dc6';
export const WIDGET_SETTINGS = {
  color: {
    theme: '#004A58'
  },
  position: { horizontal: 'right', vertical: 'bottom' }
};



// WEBPACK FOOTER //
// ./src/scripts/settings.js